import { getStationCode } from "../../network/NetworkUtil";
import {
  CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES,
  CYCLE,
  FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES,
  flowIdentifierConstant,
  INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS,
  INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION,
  INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES,
  INDIRECT_HC_FIELD_NAME_RATE,
  INDIRECT_HC_FIELD_NAME_RATIO_TO_ASSOCIATED_PROCESS,
  INDIRECT_HC_FIELD_NAME_RULE_TYPE,
  INDIRECT_HC_FIELD_NAME_VOLUME,
  INDIRECT_HC_RULE_TYPE_FIXED_HC,
  INDIRECT_HC_RULE_TYPE_RATIO,
  INDIRECT_HC_RULE_TYPE_VOLUME,
  indirectHCProcessMap,
  PROCESS,
} from "./SettingsConstant";
import { logOperationalMetric } from "../../overview/utils/utils";
import {
  getOverviewData,
  getRuleConfigurations,
  updateRuleConfigurations,
  updateStationTargets,
  deleteRuleConfigurations,
  getCoralServiceDataFromParent,
  getCycleDataFromParent,
  getTriggerConfigurations,
  setECCFLaborAvailabilityData,
  getECCFLaborAvailabilityData,
} from "../../handler/ParentDataHandler";
import { MODAL_ERROR, MODAL_SUCCESS } from "../SettingsConstant";
import { formatGetPlanDetails } from "../SettingsUtil";
import { metricProcessName, HTTP_SUCCESS_STATUS } from "../../util/Constants";
import { chainWalk } from "../../util/Util";
import { getUserLogin } from "../../resources/EmployeeResource";

const metricPlanIdentifier = "planIdentifier=" + flowIdentifierConstant;

/**
 * API to fetch station target metrics
 * @param processName
 * @param dispatcher
 */
export function fetchFlowData(processName, dispatcher) {
  const request = {
    stationCode: getStationCode(),
    processName: processName,
  };
  getFlowData(dispatcher, request);
}

async function getFlowData(dispatcher, request) {
  const args = {
    processName: "flow/" + request.processName,
    queryParams:
      "stationCode=" + request.stationCode + "&" + metricPlanIdentifier,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(startTime, metricProcessName, "getFlowData", true);
      if (result.data) {
        dispatcher({ type: "RECEIVE_FLOW_DATA", data: result.data });
      }
    } else {
      logOperationalMetric(startTime, metricProcessName, "getFlowData", false);
    }
  });
}

export function getIndirectHCRules() {
  const request = {
    queryParams: "stationCode=" + getStationCode(),
    processName: "rule-configurations",
  };
  return getRuleConfigurations(request);
}

export async function fetchTriggerConfigurationsData(dispatch) {
  const data = await getTriggerConfigurations({
    queryParams: "stationCode=" + getStationCode(),
  });

  dispatch({
    type: "UPDATE_TRIGGER_CONFIGURATIONS",
    data: {
      triggerConfigurations: data.data,
    },
  });
}

export function fetchSettingsInsight(dispatcher) {
  const request = {
    stationCode: getStationCode(),
    processName: "settings",
  };
  getSettingsInsights(dispatcher, request);
}

async function getSettingsInsights(dispatcher, request) {
  const args = {
    processName: "station-plan",
    queryParams: "stationCode=" + request.stationCode,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getSettingsInsights",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      if (result.data) {
        const settingsInsights = formatGetPlanDetails(result.data);
        dispatcher({
          type: "UPDATE_RESET_TIME",
          data: {
            settingsData: settingsInsights,
          },
        });
      }
    }
  });
}

export function deleteIndirectHCRule(rule) {
  const request = {
    stationCode: getStationCode(),
    process: rule[PROCESS],
    cycleName: rule[CYCLE],
  };
  return deleteRuleConfigurations(request);
}

export function setIndirectHCRule(rule) {
  const requestParam = {
    stationCode: getStationCode(),
    cycleName: rule[CYCLE],
    process: indirectHCProcessMap[rule[PROCESS]][PROCESS],
    [INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION]: {
      [INDIRECT_HC_FIELD_NAME_RULE_TYPE]:
        rule[INDIRECT_HC_FIELD_NAME_RULE_TYPE],
      [INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES]:
        rule[INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES],
    },
  };
  if (
    rule[INDIRECT_HC_FIELD_NAME_RULE_TYPE] === INDIRECT_HC_RULE_TYPE_FIXED_HC
  ) {
    requestParam[INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION][
      INDIRECT_HC_FIELD_NAME_RATE
    ] = rule[INDIRECT_HC_FIELD_NAME_RATE];
    requestParam[INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION][
      INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS
    ] = rule[INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS];
  }
  if (rule[INDIRECT_HC_FIELD_NAME_RULE_TYPE] === INDIRECT_HC_RULE_TYPE_RATIO) {
    requestParam[INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION][
      INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS
    ] = rule[INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS];
    requestParam[INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION][
      INDIRECT_HC_FIELD_NAME_RATIO_TO_ASSOCIATED_PROCESS
    ] = rule[INDIRECT_HC_FIELD_NAME_RATIO_TO_ASSOCIATED_PROCESS];
  } else if (
    rule[INDIRECT_HC_FIELD_NAME_RULE_TYPE] === INDIRECT_HC_RULE_TYPE_VOLUME
  ) {
    requestParam[INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION][
      INDIRECT_HC_FIELD_NAME_VOLUME
    ] = rule[INDIRECT_HC_FIELD_NAME_VOLUME];
  } else if (
    rule[INDIRECT_HC_FIELD_NAME_RULE_TYPE] === INDIRECT_HC_RULE_TYPE_FIXED_HC &&
    rule[CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES]
  ) {
    requestParam[INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION][
      FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES
    ] = rule[CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES];
    delete requestParam[INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION][
      INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES
    ];
  }
  return updateRuleConfigurations(requestParam);
}

function setFlowData(targetMap) {
  let request = {};
  request.stationCode = getStationCode();
  request.stationTargets = targetMap ? targetMap : {};
  request.planIdentifier = flowIdentifierConstant;
  return request;
}

/**
 * API to update station target metrics
 * @param processName
 * @param dispatcher
 */
export async function updateFlowData(dispatcher, targetMap) {
  const request = setFlowData(targetMap);
  const startTime = Date.now();
  updateStationTargets(request).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "updateFlowData",
        true,
      );
      if (result.data && result.data.statusCode === "OK") {
        dispatcher({
          type: "UPDATE_FLOW_RESPONSE",
          data: {
            targetMap: request.stationTargets,
          },
        });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "updateFlowData",
        false,
      );
    }
  });
}

export function fetchCycles(dispatcher) {
  getCycleDataFromParent().then((cycleData) => {
    let data = JSON.parse(cycleData.cycleList).filter(
      (cycle) => cycle.cycleId !== "AllCycles",
    );
    data = [...data];
    dispatcher({ type: "RECEIVE_CYCLE", data: { cycles: data } });
  });
}

/**
 * API to fetch opsClockData
 * @param dispatcher
 */
export function fetchOpsClockData(dispatcher, dispatchDate, actionType) {
  const request = {
    nodeId: getStationCode(),
    dispatchDate: dispatchDate,
  };

  getOpsClockData(dispatcher, request, actionType);
}

async function getOpsClockData(dispatcher, request, actionType) {
  const args = {
    processName: "lmOpsClockService",
    endPoint: "getOpsClock",
    request: JSON.stringify(request),
  };
  const startTime = Date.now();
  getCoralServiceDataFromParent(args).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getOpsClockData",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      if (result.data) {
        dispatcher({
          type: "OPS_CLOCK_DATA",
          data: {
            opsClockData: result.data,
            currentOpsClockDate: request.dispatchDate,
          },
        });

        if (actionType === "initialFetch") {
          dispatcher({
            type: "BREAKS_DATA",
            data: {
              breaksData: result.data,
              currentBreaksDate: request.dispatchDate,
            },
          });
        }
      }
    } else {
      dispatcher({
        type: "OPS_CLOCK_DATA",
        data: {
          opsClockData: { opsClock: null },
          currentOpsClockDate: request.dispatchDate,
        },
      });
    }
  });
}

export async function updateOpsClock(dispatcher, newOpsClock) {
  const request = {
    opsClock: newOpsClock,
    userId: await getUserLogin(),
  };

  updateOpsClockData(dispatcher, request);
}

async function updateOpsClockData(dispatcher, request) {
  const args = {
    processName: "lmOpsClockService",
    endPoint: "updateOpsClock",
    request: JSON.stringify(request),
  };
  const startTime = Date.now();
  getCoralServiceDataFromParent(args).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "updateOpsClockData",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      dispatcher({
        type: "UPDATE_PLAN_RESPONSE",
        data: {
          showUpdatePlanResponseModal: MODAL_SUCCESS,
          message: "Ops clock data updated successfully",
          opsClockData: { opsClock: request.opsClock },
        },
      });
    } else {
      dispatcher({
        type: "UPDATE_PLAN_RESPONSE",
        data: {
          showUpdatePlanResponseModal: MODAL_ERROR,
          message: "Error while updating ops clock data",
        },
      });
    }
  });
}

/**
 * API to fetch breaksData
 * @param dispatcher
 */
export function fetchBreaksData(dispatcher, dispatchDate) {
  const request = {
    nodeId: getStationCode(),
    dispatchDate: dispatchDate,
  };

  getBreaksData(dispatcher, request);
}

async function getBreaksData(dispatcher, request) {
  const args = {
    processName: "lmOpsClockService",
    request: JSON.stringify(request),
  };
  const startTime = Date.now();
  let clockEvents = [];
  getCoralServiceDataFromParent({
    ...args,
    endPoint: "getOpsClock",
  })
    .then((result) => {
      if (result.status === 200) {
        clockEvents = chainWalk(() => result.data.opsClock.clockEvents, []);
        return getCoralServiceDataFromParent({
          ...args,
          endPoint: "getBreaks",
        });
      } else {
        return Promise.reject();
      }
    })
    .then((result) => {
      if (result.status === 200) {
        logOperationalMetric(
          startTime,
          metricProcessName,
          "getBreaksData",
          true,
        );
        if (result.data && result.data.opsClock) {
          const breaksData = result.data;
          breaksData.opsClock.clockEvents = clockEvents;
          breaksData.opsClock.dispatchDate = request.dispatchDate;
          dispatcher({
            type: "BREAKS_DATA",
            data: {
              breaksData,
              currentBreaksDate: request.dispatchDate,
            },
          });
        }
      } else {
        return Promise.reject();
      }
    })
    .catch(() => {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getBreaksData",
        false,
      );
      dispatcher({
        type: "BREAKS_DATA",
        data: {
          breaksData: { opsClock: null },
          currentBreaksDate: request.dispatchDate,
        },
      });
    });
}

export async function updateBreaks(
  dispatcher,
  newOpsClock,
  showUpdateBreakModal,
) {
  const request = {
    opsClock: newOpsClock,
    userId: await getUserLogin(),
  };

  updateBreaksData(dispatcher, request, showUpdateBreakModal);
}

async function updateBreaksData(dispatcher, request, showUpdateBreakModal) {
  const args = {
    processName: "lmOpsClockService",
    endPoint: "updateOpsClock",
    request: JSON.stringify(request),
  };
  const startTime = Date.now();
  getCoralServiceDataFromParent(args).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "updateBreaksData",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      dispatcher({
        type: "UPDATE_PLAN_RESPONSE",
        data: {
          showUpdatePlanResponseModal: showUpdateBreakModal
            ? MODAL_SUCCESS
            : null,
          message: "Breaks data updated successfully",
          breaksData: { opsClock: request.opsClock },
        },
      });
    } else {
      dispatcher({
        type: "UPDATE_PLAN_RESPONSE",
        data: {
          showUpdatePlanResponseModal: MODAL_ERROR,
          message: "Error while updating breaks data",
        },
      });
    }
  });
}

export const getLMOpsCoralServiceRequest = (endPoint, requestBody) => {
  return {
    processName: "lmOpsClockService",
    endPoint,
    request: JSON.stringify(requestBody),
  };
};

export async function updateDefaultClockConfiguration(
  dispatcher,
  newConfiguration,
) {
  const request = {
    defaultClockConfiguration: newConfiguration,
    userId: await getUserLogin(),
  };
  updateDefaultClockConfigurationData(dispatcher, request);
}

export async function getECCFLaborAvailabilityS3DownloadUrl(resourceType) {
  const request = {
    operationType: "get",
    queryParams:
      "stationCode=" + getStationCode() + "&resourceType=" + resourceType,
  };
  return getECCFLaborAvailabilityData(request);
}

export async function getECCFLaborAvailabilityS3UploadUrl(resourceType) {
  const request = {
    operationType: "upload",
    queryParams:
      "stationCode=" + getStationCode() + "&resourceType=" + resourceType,
  };
  return setECCFLaborAvailabilityData(request);
}

async function updateDefaultClockConfigurationData(dispatcher, request) {
  const args = {
    processName: "lmOpsClockService",
    endPoint: "updateDefaultClockConfiguration",
    request: JSON.stringify(request),
  };
  const startTime = Date.now();

  getCoralServiceDataFromParent(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "updateDefaultClockConfiguration",
        result.status === HTTP_SUCCESS_STATUS,
      );
      dispatcher({
        type: "UPDATE_DEFAULT_CLOCK_CONFIGURATION_RESPONSE",
        data: {
          showUpdatePlanResponseModal: MODAL_SUCCESS,
          message:
            "Reset time updated successfully. It might take upto 5 minutes for the changes to reflect",
          defaultClockConfiguration: request.defaultClockConfiguration,
          dispatcher: dispatcher,
        },
      });
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "updateDefaultClockConfiguration",
        false,
      );
      dispatcher({
        type: "UPDATE_DEFAULT_CLOCK_CONFIGURATION_RESPONSE",
        data: {
          showUpdatePlanResponseModal: MODAL_ERROR,
          message: "Error while updating reset time",
          dispatcher: dispatcher,
        },
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/SettingsNetworkAPI.js